// Mapear datos del API al formato esperado por los componentes

export const mapClientToContact = (client) => {
  // Validar que client existe y tiene id
  if (!client) {
    console.error('mapClientToContact: client es null o undefined');
    return null;
  }
  
  if (client.id === undefined || client.id === null) {
    console.error('mapClientToContact: client.id es undefined o null', client);
    return null;
  }
  
  const mapAddress = (addr) => ({
    id: addr.id ? String(addr.id) : undefined,
    addressType: addr.address_type || '',
    name: addr.name || '',
    street: addr.street || '',
    street2: addr.street2 || '',
    city: addr.city || '',
    state: addr.state || '',
    country: addr.country || 'Argentina',
    postalCode: addr.postal_code || '',
    email: addr.email || '',
    phone: addr.phone || '',
    mobile: addr.mobile || '',
    wechatId: addr.wechat_id || '',
    qq: addr.qq || '',
    category: addr.category || '',
  });

  return {
    id: String(client.id),
    codigoContacto: client.codigo_contacto || '',
    contactType: client.contact_type || 'CLIENT',
    name: client.name || '',
    fantasyName: client.fantasy_name || '',
    position: client.position || '',
    area: client.area || '',
    email: client.email || '',
    phone: client.phone || '',
    mobile: client.mobile || '',
    postalCode: client.postal_code || '',
    comprador: client.comprador || '',
    address: client.address || '',
    city: client.city || '',
    stateProvince: client.state_province || '',
    country: client.country || '',
    categories: client.categories || '',
    wechatId: client.wechat_id || '',
    website: client.website || '',
    description: client.description || '',
    relationshipStartDate: client.relationship_start_date || '',
    agentId: client.agent_id ? String(client.agent_id) : '',
    agentName: client.agent_name || '',
    agentCode: client.agent_code || '',
    factoryPortId: client.factory_port_id ? String(client.factory_port_id) : '',
    destinationPorts: Array.isArray(client.destination_ports) ? client.destination_ports : [],
    destinationPortIds: Array.isArray(client.destination_ports)
      ? client.destination_ports.map((port) => String(port.id))
      : [],
    loadPortId: client.load_port_id ? String(client.load_port_id) : '',
    destinationPortText: client.destination_port_text || '',
    paymentMethodId: client.payment_method ? String(client.payment_method) : '',
    paymentMethodName: client.payment_method_name || '',
    creditDaysId: client.credit_days ? String(client.credit_days) : '',
    creditDaysValue: client.credit_days_value ?? null,
    balancePaymentId: client.balance_payment ? String(client.balance_payment) : '',
    balancePaymentName: client.balance_payment_name || '',
    advancePaymentId: client.advance_payment ? String(client.advance_payment) : '',
    advancePaymentName: client.advance_payment_name || '',
    paymentTerm: client.payment_term || '',
    beneficiaryAccountName: client.beneficiary_account_name || '',
    commissionPercentage: client.commission_percentage ?? '',
    supplierCurrencies: Array.isArray(client.supplier_currencies) ? client.supplier_currencies : [],
    beneficiaryBankAddress: client.beneficiary_bank_address || '',
    swiftBic: client.swift_bic || '',
    routingAba: client.routing_aba || '',
    receiptReminder: client.receipt_reminder || '',
    labelType: client.label_type || '',
    taxInformation: client.tax_information || '',
    discountPercentage: client.discount_percentage ?? '',
    discountListId: client.discount_list ? String(client.discount_list) : '',
    discountListName: client.discount_list_name || '',
    kam: client.kam || '',
    salesTeam: client.sales_team || '',
    priceList: client.price_list || '',
    reference: client.reference || '',
    sector: client.sector || '',
    idType: client.id_type || '',
    idNumber: client.id_number || '',
    bank: client.bank || '',
    accountNumber: client.account_number || '',
    notifyParty: client.notify_party || '',
    consignee: client.consignee || '',
    transitId: client.transit_id || '',
    requirements: client.requirements || '',
    shippingInstructions: client.shipping_instructions || '',
    storeNumber: client.store_number || '',
    storeFormat: client.store_format || '',
    fairs: client.fairs || '',
    stateId: client.state_id ? String(client.state_id) : '',
    stateName: client.state_name || '',
    billingAddress: client.billing_address || '',
    empresaNombre: client.empresa_nombre || '',
    contactPersons: Array.isArray(client.contact_persons) ? client.contact_persons.map((cp) => ({
      id: cp.id,
      name: cp.name || '',
      area: cp.area || '',
      position: cp.position || '',
      email: cp.email || '',
      phone: cp.phone || '',
      wechatId: cp.wechat_id || '',
      categories: cp.categories || '',
    })) : [],
    addresses: Array.isArray(client.addresses) ? client.addresses.map(mapAddress) : [],
    companyId: client.company_id ? String(client.company_id) : '',
    companies: Array.isArray(client.companies)
      ? client.companies
      : (client.company ? [client.company] : []),
    companyIds: Array.isArray(client.companies)
      ? client.companies.map((c) => String(c.id))
      : (client.company_id ? [String(client.company_id)] : []),
    status: client.status || 'Borrador',
    comments: client.comments || '',
    lastContact: client.last_contact ? new Date(client.last_contact) : new Date(),
    createdAt: client.created_at ? new Date(client.created_at) : new Date(),
  };
};


export const mapInteractionToFormat = (interaction) => {
  // Validar que interaction existe y tiene id
  if (!interaction) {
    console.error('mapInteractionToFormat: interaction es null o undefined');
    return null;
  }
  
  if (interaction.id === undefined || interaction.id === null) {
    console.error('mapInteractionToFormat: interaction.id es undefined o null', interaction);
    return null;
  }
  
  return {
    id: interaction.id.toString(),
    contactId: interaction.contact_id ? interaction.contact_id.toString() : '',
    date: interaction.date ? new Date(interaction.date) : new Date(),
    type: interaction.type || '',
    summary: interaction.summary || '',
    attachment: interaction.attachment || null,
    createdAt: interaction.created_at ? new Date(interaction.created_at) : new Date(),
    updatedAt: interaction.updated_at ? new Date(interaction.updated_at) : null,
  };
};

// Mapear datos del frontend al formato del API
export const mapContactToClient = (contact) => {
  // Función helper para convertir IDs a strings (el backend espera List[str])
  const parseIds = (ids) => {
    if (!ids) return [];
    if (Array.isArray(ids)) {
      return ids
        .map(id => {
          if (id === null || id === undefined || id === '') return null;
          // Convertir a string, no a número
          const idStr = String(id).trim();
          return idStr !== '' ? idStr : null;
        })
        .filter(id => id !== null);
    }
    // Si es string, convertir a array
    if (typeof ids === 'string' && ids.trim() !== '') {
      return [ids.trim()];
    }
    // Si es número, convertir a string
    if (typeof ids === 'number') {
      return [String(ids)];
    }
    return [];
  };

  // Validar que name sea string válido
  const name = String(contact.name || '').trim();
  const email = String(contact.email || '').trim();

  if (!name) {
    throw new Error('El nombre es requerido');
  }

  const mapAddressToAPI = (addr) => {
    const mapped = {
      address_type: addr.addressType,
      name: addr.name || null,
      street: addr.street || null,
      street2: addr.street2 || null,
      city: addr.city || null,
      state: addr.state || null,
      country: addr.country || 'Argentina',
      postal_code: addr.postalCode || null,
      email: addr.email || null,
      phone: addr.phone || null,
      mobile: addr.mobile || null,
      wechat_id: addr.wechatId || null,
      qq: addr.qq || null,
      category: addr.category || null,
    };
    if (addr.id) mapped.id = parseInt(addr.id, 10);
    return mapped;
  };

  const str = (v) => v ? String(v).trim() : null;
  const dec = (v) => v !== '' && v !== null && v !== undefined ? parseFloat(v) : null;

  const result = {
    name: name,
    contact_type: String(contact.contactType || 'CLIENT').trim(),
    fantasy_name: str(contact.fantasyName),
    position: str(contact.position),
    area: str(contact.area),
    email: email,
    phone: str(contact.phone),
    mobile: str(contact.mobile),
    postal_code: str(contact.postalCode),
    comprador: str(contact.comprador),
    address: str(contact.address),
    city: str(contact.city),
    state_province: str(contact.stateProvince),
    country: str(contact.country),
    categories: str(contact.categories),
    wechat_id: str(contact.wechatId),
    website: str(contact.website),
    description: str(contact.description),
    relationship_start_date: contact.relationshipStartDate || null,
    agent_id: contact.agentId ? parseInt(contact.agentId) : null,
    factory_port_id: contact.factoryPortId ? parseInt(contact.factoryPortId) : null,
    destination_port_ids: Array.isArray(contact.destinationPortIds)
      ? contact.destinationPortIds.map((id) => parseInt(id)).filter((id) => !isNaN(id))
      : [],
    load_port_id: contact.loadPortId ? parseInt(contact.loadPortId) : null,
    destination_port_text: str(contact.destinationPortText),
    payment_method: contact.paymentMethodId ? parseInt(contact.paymentMethodId) : null,
    credit_days: contact.creditDaysId ? parseInt(contact.creditDaysId) : null,
    balance_payment: contact.balancePaymentId ? parseInt(contact.balancePaymentId) : null,
    advance_payment: contact.advancePaymentId ? parseInt(contact.advancePaymentId) : null,
    payment_term: str(contact.paymentTerm),
    beneficiary_account_name: str(contact.beneficiaryAccountName),
    commission_percentage: dec(contact.commissionPercentage),
    supplier_currencies: Array.isArray(contact.supplierCurrencies) ? contact.supplierCurrencies : [],
    beneficiary_bank_address: str(contact.beneficiaryBankAddress),
    swift_bic: str(contact.swiftBic),
    routing_aba: str(contact.routingAba),
    receipt_reminder: str(contact.receiptReminder),
    label_type: str(contact.labelType),
    tax_information: str(contact.taxInformation),
    discount_percentage: dec(contact.discountPercentage),
    discount_list: contact.discountListId ? parseInt(contact.discountListId) : null,
    kam: str(contact.kam),
    sales_team: str(contact.salesTeam),
    price_list: str(contact.priceList),
    reference: str(contact.reference),
    sector: str(contact.sector),
    id_type: str(contact.idType),
    id_number: str(contact.idNumber),
    bank: str(contact.bank),
    account_number: str(contact.accountNumber),
    notify_party: str(contact.notifyParty),
    consignee: str(contact.consignee),
    transit_id: str(contact.transitId),
    requirements: str(contact.requirements),
    shipping_instructions: str(contact.shippingInstructions),
    store_number: str(contact.storeNumber),
    store_format: str(contact.storeFormat),
    fairs: str(contact.fairs),
    state_id: contact.stateId ? parseInt(contact.stateId) : null,
    billing_address: str(contact.billingAddress),
    empresa_nombre: str(contact.empresaNombre),
    company_id: contact.companyId ? parseInt(contact.companyId) : null,
    company_ids: contact.companyIds ? contact.companyIds.map(id => parseInt(id)).filter(id => !isNaN(id)) : [],
    status: contact.status ? String(contact.status).trim() : 'Borrador',
    comments: str(contact.comments),
  };

  if (contact.codigoContacto) {
    result.codigo_contacto = String(contact.codigoContacto).trim();
  }

  if (Array.isArray(contact.contactPersons)) {
    result.contact_persons_data = contact.contactPersons
      .filter((cp) => cp.name)
      .map((cp) => ({
        id: cp.id || undefined,
        name: cp.name,
        area: cp.area || null,
        position: cp.position || null,
        email: cp.email || null,
        phone: cp.phone || null,
        wechat_id: cp.wechatId || null,
        categories: cp.categories || null,
      }));
  }

  if (Array.isArray(contact.addresses) && contact.addresses.length > 0) {
    result.addresses_data = contact.addresses
      .filter((a) => a.addressType && (a.name || a.street || a.street2 || a.city || a.state || a.country || a.postalCode || a.email || a.phone))
      .map(mapAddressToAPI);
  }

  return result;
};


export const mapInteractionToAPI = (interaction) => {
  return {
    contact_id: parseInt(interaction.contactId),
    date: interaction.date instanceof Date 
      ? interaction.date.toISOString() 
      : interaction.date,
    type: interaction.type,
    summary: interaction.summary,
    attachment: interaction.attachment || null,
  };
};

export const mapActivityToFormat = (activity) => {
  return {
    id: activity.id.toString(),
    entityType: activity.entity_type,
    entityId: activity.entity_id,
    action: activity.action,
    description: activity.description,
    changes: activity.changes || {},
    metaData: activity.meta_data || {},
    userId: activity.user_id ? activity.user_id.toString() : null,
    createdAt: activity.created_at ? new Date(activity.created_at) : new Date(),
  };
};

export const mapCompanyToFormat = (company) => {
  // Validar que company existe y tiene id
  if (!company) {
    console.error('mapCompanyToFormat: company es null o undefined');
    return null;
  }
  
  if (company.id === undefined || company.id === null) {
    console.error('mapCompanyToFormat: company.id es undefined o null', company);
    return null;
  }
  
  return {
    id: String(company.id),
    companyRole: company.company_role || 'CLIENT',
    name: company.name || '',
    razonSocial: company.razon_social || '',
    cuit: company.cuit || '',
    codigoContacto: company.codigo_contacto || '',
    comprador: company.comprador || '',
    descripcion: company.descripcion || '',
    address: company.address || '',
    city: company.city || '',
    state: company.state || '',
    country: company.country || 'Argentina',
    phone: company.phone || '',
    email: company.email || '',
    website: company.website || '',
    notes: company.notes || '',
    paymentMethod: company.payment_method || null,
    paymentMethodName: company.payment_method_name || '',
    creditDays: company.credit_days || null,
    creditDaysValue: company.credit_days_value || null,
    balancePayment: company.balance_payment || null,
    balancePaymentName: company.balance_payment_name || '',
    bankAccounts: Array.isArray(company.bank_accounts) ? company.bank_accounts.map((acc) => ({
      id: acc.id ? String(acc.id) : undefined,
      beneficiaryAccountName: acc.beneficiary_account_name || '',
      beneficiaryBankAddress: acc.beneficiary_bank_address || '',
      routingAba: acc.routing_aba || '',
      swiftBic: acc.swift_bic || '',
      accountNumber: acc.account_number || '',
      currency: acc.currency || '',
    })) : [],
    companyPorts: Array.isArray(company.company_ports) ? company.company_ports.map((cp) => ({
      id: cp.id ? String(cp.id) : undefined,
      portId: cp.port_id ? String(cp.port_id) : (cp.port ? String(cp.port) : ''),
      portName: cp.port_name || '',
      portType: cp.port_type || 'DESTINATION_PORT',
    })) : [],
    createdAt: company.created_at ? new Date(company.created_at) : new Date(),
    updatedAt: company.updated_at ? new Date(company.updated_at) : null,
  };
};

export const mapCompanyToAPI = (company) => {
  return {
    company_role: company.companyRole || 'CLIENT',
    name: company.name,
    razon_social: company.razonSocial || null,
    cuit: company.cuit || null,
    codigo_contacto: company.codigoContacto || null,
    comprador: company.comprador || null,
    descripcion: company.descripcion || null,
    address: company.address || null,
    city: company.city || null,
    state: company.state || null,
    country: company.country || 'Argentina',
    phone: company.phone || null,
    email: company.email || null,
    website: company.website || null,
    notes: company.notes || null,
    payment_method: company.paymentMethodId ? parseInt(company.paymentMethodId) : null,
    credit_days: company.creditDaysId ? parseInt(company.creditDaysId) : null,
    balance_payment: company.balancePaymentId ? parseInt(company.balancePaymentId) : null,
    bank_accounts: Array.isArray(company.bankAccounts) ? company.bankAccounts.map((acc) => ({
      beneficiary_account_name: acc.beneficiaryAccountName || null,
      beneficiary_bank_address: acc.beneficiaryBankAddress || null,
      routing_aba: acc.routingAba || null,
      swift_bic: acc.swiftBic || null,
      account_number: acc.accountNumber || null,
      currency: acc.currency || null,
    })) : [],
    company_ports: Array.isArray(company.companyPorts) ? company.companyPorts
      .filter((cp) => cp.portId)
      .map((cp) => ({
        port: parseInt(cp.portId),
        port_type: cp.portType || 'DESTINATION_PORT',
      })) : [],
  };
};

// Mapear competidores
export const mapCompetitorToFormat = (competitor) => {
  // Validar que competitor existe y tiene id
  if (!competitor) {
    console.error('mapCompetitorToFormat: competitor es null o undefined');
    return null;
  }
  
  if (competitor.id === undefined || competitor.id === null) {
    console.error('mapCompetitorToFormat: competitor.id es undefined o null', competitor);
    return null;
  }
  
  return {
    id: competitor.id.toString(),
    name: competitor.name || '',
    description: competitor.description || '',
    marketShare: competitor.market_share || 0,
    strengths: Array.isArray(competitor.strengths) ? competitor.strengths : [],
    weaknesses: Array.isArray(competitor.weaknesses) ? competitor.weaknesses : [],
    createdAt: competitor.created_at ? new Date(competitor.created_at) : new Date(),
    updatedAt: competitor.updated_at ? new Date(competitor.updated_at) : null,
  };
};

export const mapCompetitorToAPI = (competitor) => {
  return {
    name: competitor.name,
    description: competitor.description || null,
    market_share: parseInt(competitor.marketShare) || 0,
    strengths: Array.isArray(competitor.strengths) ? competitor.strengths : [],
    weaknesses: Array.isArray(competitor.weaknesses) ? competitor.weaknesses : [],
  };
};

// Mapear propuestas (items estructurados, sin economic_proposal JSON)
export const mapProposalToFormat = (proposal) => {
  // Validar que proposal existe y tiene id
  if (!proposal) {
    console.error('mapProposalToFormat: proposal es null o undefined');
    return null;
  }
  
  if (proposal.id === undefined || proposal.id === null) {
    console.error('mapProposalToFormat: proposal.id es undefined o null', proposal);
    return null;
  }

  return {
    id: proposal.id.toString(),
    proposalId: proposal.proposal_id,
    // CRÍTICO: Verificar que contact_id no sea null antes de llamar toString()
    contactId: proposal.contact_id !== null && proposal.contact_id !== undefined 
      ? proposal.contact_id.toString() 
      : '',
    companyId: proposal.company_id ? proposal.company_id.toString() : '',
    companyName: proposal.company_name || '',
    createdByName: proposal.created_by_name || '',
    status: proposal.status || 'Borrador',
    proforma: proposal.proforma || false,
    stage: proposal.stage || 'Media',
    greeting: proposal.greeting || '',
    salutation: proposal.salutation || 'Sr.',
    commercial_note: proposal.commercial_note || '',
    // Items estructurados (reemplaza economic_proposal JSON)
    items: Array.isArray(proposal.items) ? proposal.items.map(item => ({
      id: item.id,
      product_id: item.product,
      product_name: item.product_name || '',
      product_code: item.product_code || '',
      brand_name: item.brand_name || '',
      category_name: item.category_name || '',
      factory_name: item.factory_name || '',
      pcs_per_ctn: item.pcs_per_ctn,
      cbm_per_ctn: item.cbm_per_ctn,
      moq: item.moq,
      quantity: item.quantity || 1,
      price_fob_unit: item.price_fob_unit || 0,
      total: item.total || 0,
      product_variant: item.product_variant || '',
      packaging_type_name: item.packaging_type_name || '',
      inners: item.inners,
      manufacturer_code: item.manufacturer_code || '',
      material_composition: item.material_composition || '',
      recommended_age: item.recommended_age || '',
      battery_info: item.battery_info || '',
      product_image: item.product_image || '',
      product_size: item.product_size || '',
      description: item.description || '',
      product_height: item.product_height,
      product_length: item.product_length,
      product_width: item.product_width,
      packaging_height: item.packaging_height,
      packaging_length: item.packaging_length,
      packaging_width: item.packaging_width,
      pieces: item.pieces,
      moq_oem: item.moq_oem,
      assortment: item.assortment || '',
      discount_fob: item.discount_fob,
      master_pack_height: item.master_pack_height,
      master_pack_length: item.master_pack_length,
      master_pack_width: item.master_pack_width,
      master_pack_gw: item.master_pack_gw,
      master_pack_nw: item.master_pack_nw,
      port_name: item.port_name || '',
      link_web: item.link_web || '',
    })) : [],
    paymentTerms: proposal.payment_terms || '',
    rebate: proposal.rebate ?? '',
    priceListId: proposal.price_list_id ? String(proposal.price_list_id) : '',
    priceListName: proposal.price_list_name || '',
    contactName: proposal.contact_name || '',
    totalAmount: proposal.total_amount || 0,
    sentDate: proposal.sent_date ? new Date(proposal.sent_date) : null,
    approvedDate: proposal.approved_date ? new Date(proposal.approved_date) : null,
    expiryDate: proposal.expiry_date ? new Date(proposal.expiry_date) : null,
    createdAt: proposal.created_at ? new Date(proposal.created_at) : new Date(),
    updatedAt: proposal.updated_at ? new Date(proposal.updated_at) : null,
    invoiceFile: proposal.invoice_file || null,
    customerOrderId: proposal.customer_order_id || null,
    customerOrderCode: proposal.customer_order_code || null,
  };
};

export const mapProposalToAPI = (proposal) => {
  // Validar contactId antes de parsear
  const contactId = proposal.contactId;
  let contact_id_value = null;
  
  if (contactId !== undefined && contactId !== null && contactId !== '') {
    try {
      const parsed = parseInt(contactId);
      if (!isNaN(parsed) && parsed > 0) {
        contact_id_value = parsed;
      }
    } catch (e) {
      console.warn('Error parseando contactId:', e);
    }
  }
  
  // Si es una actualización (tiene id) y no hay contact_id válido, lanzar error
  if (proposal.id && !contact_id_value) {
    console.error('Error: Se intenta actualizar una cotización sin contactId válido', proposal);
    throw new Error('El contacto es obligatorio para actualizar la cotización');
  }

  const apiData = {
    ...(contact_id_value !== null && contact_id_value !== undefined ? { contact_id: contact_id_value } : {}),
    company_id: proposal.companyId ? parseInt(proposal.companyId) : null,
    status: proposal.status || 'Borrador',
    proforma: proposal.proforma !== undefined ? proposal.proforma : false,
    stage: proposal.stage || 'Media',
    greeting: proposal.greeting || '',
    salutation: proposal.salutation || 'Sr.',
    commercial_note: proposal.commercial_note || '',
    payment_terms: proposal.paymentTerms || null,
    rebate: proposal.rebate !== '' && proposal.rebate !== null && proposal.rebate !== undefined ? parseFloat(proposal.rebate) : null,
    price_list_id: proposal.priceListId ? parseInt(proposal.priceListId) : null,
    items: (proposal.items || [])
      .filter(item => item.product_id)
      .map(item => ({
        product_id: parseInt(item.product_id),
        quantity: parseInt(item.quantity) || 1,
        price_fob_unit: parseFloat(item.price_fob_unit) || 0,
        moq: item.moq ? parseInt(item.moq) : null,
      })),
    total_amount: proposal.totalAmount || 0,
  };

  // Solo incluir fechas si tienen valores válidos
  if (proposal.expiryDate) {
    apiData.expiry_date = proposal.expiryDate instanceof Date 
      ? proposal.expiryDate.toISOString() 
      : proposal.expiryDate;
  }
  if (proposal.sentDate) {
    apiData.sent_date = proposal.sentDate instanceof Date 
      ? proposal.sentDate.toISOString() 
      : proposal.sentDate;
  }
  if (proposal.approvedDate) {
    apiData.approved_date = proposal.approvedDate instanceof Date 
      ? proposal.approvedDate.toISOString() 
      : proposal.approvedDate;
  }

  if (proposal.invoiceFile && proposal.invoiceFile.trim()) {
    apiData.invoice_file = proposal.invoiceFile;
  }

  return apiData;
};

// Mapear productos del API al formato esperado por los componentes
export const mapProductToFormat = (product) => {
  // Validar que product existe y tiene id
  if (!product) {
    console.error('mapProductToFormat: product es null o undefined');
    return null;
  }
  
  if (product.id === undefined || product.id === null) {
    console.error('mapProductToFormat: product.id es undefined o null', product);
    return null;
  }
  
  return {
    id: product.id.toString(),
    name: product.name,
    product_code: product.product_code || '',
    description: product.description || '',
    category_id: product.category_id || null,
    category: product.category || product.category_name || (product.category_rel?.name) || '',
    brand_id: product.brand_id || null,
    brand_name: product.brand_name || '',
    product_line_id: product.product_line_id || null,
    product_line_name: product.product_line_name || '',
    tag_ids: product.tag_ids || [],
    tag_names: product.tag_names || [],
    brand_type: product.brand_type || 'GENERIC',
    product_status: product.product_status || 'DRAFT',
    agent_id: product.agent_id || null,
    agent_name: product.agent_name || '',
    is_for_sale: product.is_for_sale !== false,
    is_purchasable: product.is_purchasable !== false,
    unit_price: product.unit_price || 0,
    list_prices: Array.isArray(product.list_prices) ? product.list_prices : [],
    cost: product.cost || 0,
    profit_margin: product.profit_margin || 0,
    cost_percentage: product.cost_percentage || 0,
    incoterm: product.incoterm || 'FOB',
    cost_rmb: product.cost_rmb ?? '',
    cost_fob: product.cost_fob ?? '',
    price_fob: product.price_fob ?? '',
    pcs_per_ctn: product.pcs_per_ctn ?? '',
    cbm_per_ctn: product.cbm_per_ctn ?? '',
    factory_port: product.factory_port || null,
    shipping_port: product.shipping_port || null,
    unit: product.unit || 'unidad',
    stock: product.stock || 0,
    is_service: product.is_service || false,
    is_active: product.is_active || 'true',
    assortment: product.assortment || '',
    pieces: product.pieces ?? '',
    material_composition: product.material_composition || '',
    size: product.size || '',
    packaging_type_id: product.packaging_type_id || null,
    packaging_type_name: product.packaging_type_name || '',
    uses_batteries: product.uses_batteries || false,
    batteries_included: product.batteries_included || false,
    recommended_age: product.recommended_age || '',
    battery_type_id: product.battery_type_id || null,
    battery_type_name: product.battery_type_name || '',
    moq: product.moq ?? '',
    moq_oem: product.moq_oem ?? '',
    discount_fob: product.discount_fob ?? '',
    product_variant: product.product_variant || '',
    battery_info: product.battery_info || '',
    accessories: product.accessories || '',
    added_date: product.added_date || '',
    inner_ctn: product.inner_ctn ?? '',
    factory_id: product.factory_id || null,
    factory_name: product.factory_name || '',
    manufacturer_code: product.manufacturer_code || '',
    main_image: product.main_image || '',
    gallery_images: product.gallery_images || [],
    video_url: product.video_url || '',
    product_improvements: product.product_improvements || '',
    ean: product.ean || '',
    dun: product.dun || '',
    product_height: product.product_height ?? '',
    product_length: product.product_length ?? '',
    product_width: product.product_width ?? '',
    master_pack_height: product.master_pack_height ?? '',
    master_pack_length: product.master_pack_length ?? '',
    master_pack_width: product.master_pack_width ?? '',
    master_pack_gross_weight: product.master_pack_gross_weight ?? '',
    master_pack_net_weight: product.master_pack_net_weight ?? '',
    units_per_master: product.units_per_master ?? '',
    original_factory_cost: product.original_factory_cost ?? '',
    best_cost_with_order: product.best_cost_with_order ?? '',
    ecommerce_description: product.ecommerce_description || '',
    price_currency: product.price_currency || 'USD',
    cost_currency: product.cost_currency || 'USD',
    moq_factory_pack: product.moq_factory_pack ?? '',
    logistics_factor: product.logistics_factor ?? '',
    packaging_height: product.packaging_height ?? '',
    packaging_length: product.packaging_length ?? '',
    packaging_width: product.packaging_width ?? '',
    ce_logo: product.ce_logo || false,
    ukca_logo: product.ukca_logo || false,
    cert_en71: product.cert_en71 || false,
    cert_ftalatos: product.cert_ftalatos || false,
    cert_tolueno: product.cert_tolueno || false,
    cert_benceno: product.cert_benceno || false,
    created_at: product.created_at ? new Date(product.created_at) : new Date(),
    updated_at: product.updated_at ? new Date(product.updated_at) : null,
  };
};

// Mapear productos del formato del componente al API
export const mapProductToAPI = (product) => {
  return {
    name: product.name,
    product_code: product.product_code || null,
    description: product.description || null,
    category_id: product.category_id ? parseInt(product.category_id) : null,
    category: product.category || null, // Mantener para compatibilidad
    brand_id: product.brand_id ? parseInt(product.brand_id) : null,
    product_line_id: product.product_line_id ? parseInt(product.product_line_id) : null,
    tag_ids: Array.isArray(product.tag_ids) ? product.tag_ids.map(id => parseInt(id)) : [],
    brand_type: product.brand_type || 'GENERIC',
    product_status: product.product_status || 'DRAFT',
    agent_id: product.agent_id ? parseInt(product.agent_id) : null,
    is_for_sale: product.is_for_sale !== false,
    is_purchasable: product.is_purchasable !== false,
    unit_price: parseFloat(product.unit_price) || 0,
    price_currency: product.price_currency || 'USD',
    cost: parseFloat(product.cost) || 0,
    cost_currency: product.cost_currency || 'USD',
    stock: product.stock !== '' && product.stock !== null && product.stock !== undefined ? parseFloat(product.stock) : 0,
    profit_margin: parseFloat(product.profit_margin) || 0,
    cost_percentage: parseFloat(product.cost_percentage) || 0,
    incoterm: product.incoterm || 'FOB',
    cost_rmb: product.cost_rmb !== '' && product.cost_rmb !== null ? parseFloat(product.cost_rmb) : null,
    cost_fob: product.cost_fob !== '' && product.cost_fob !== null ? parseFloat(product.cost_fob) : null,
    price_fob: product.price_fob !== '' && product.price_fob !== null ? parseFloat(product.price_fob) : null,
    pcs_per_ctn: product.pcs_per_ctn !== '' && product.pcs_per_ctn !== null ? parseInt(product.pcs_per_ctn) : null,
    cbm_per_ctn: product.cbm_per_ctn !== '' && product.cbm_per_ctn !== null ? parseFloat(product.cbm_per_ctn) : null,
    factory_port: product.factory_port ? parseInt(product.factory_port) : null,
    shipping_port: product.shipping_port ? parseInt(product.shipping_port) : null,
    is_service: product.is_service || false,
    unit: product.unit || 'unidad',
    is_active: product.is_active || 'true',
    assortment: product.assortment || null,
    pieces: product.pieces !== '' && product.pieces !== null ? parseInt(product.pieces) : null,
    material_composition: product.material_composition || null,
    size: product.size || null,
    packaging_type_id: product.packaging_type_id ? parseInt(product.packaging_type_id) : null,
    uses_batteries: product.uses_batteries || false,
    batteries_included: product.uses_batteries ? !!product.batteries_included : false,
    recommended_age: product.recommended_age || null,
    battery_type_id: product.battery_type_id ? parseInt(product.battery_type_id) : null,
    moq: product.moq !== '' && product.moq !== null ? parseInt(product.moq) : null,
    moq_oem: product.moq_oem !== '' && product.moq_oem !== null ? parseInt(product.moq_oem) : null,
    discount_fob: product.discount_fob !== '' && product.discount_fob !== null ? parseFloat(product.discount_fob) : null,
    product_variant: product.product_variant || null,
    battery_info: product.battery_info || null,
    accessories: product.accessories || null,
    added_date: product.added_date || null,
    inner_ctn: product.inner_ctn !== '' && product.inner_ctn !== null ? parseInt(product.inner_ctn) : null,
    factory_id: product.factory_id ? parseInt(product.factory_id) : null,
    manufacturer_code: product.manufacturer_code || null,
    main_image: product.main_image || null,
    gallery_images: product.gallery_images || [],
    video_url: product.video_url || null,
    product_improvements: product.product_improvements || null,
    ecommerce_description: product.ecommerce_description || null,
    ean: product.ean || null,
    dun: product.dun || null,
    product_height: product.product_height !== '' && product.product_height !== null ? parseFloat(product.product_height) : null,
    product_length: product.product_length !== '' && product.product_length !== null ? parseFloat(product.product_length) : null,
    product_width: product.product_width !== '' && product.product_width !== null ? parseFloat(product.product_width) : null,
    master_pack_height: product.master_pack_height !== '' && product.master_pack_height !== null ? parseFloat(product.master_pack_height) : null,
    master_pack_length: product.master_pack_length !== '' && product.master_pack_length !== null ? parseFloat(product.master_pack_length) : null,
    master_pack_width: product.master_pack_width !== '' && product.master_pack_width !== null ? parseFloat(product.master_pack_width) : null,
    master_pack_gross_weight: product.master_pack_gross_weight !== '' && product.master_pack_gross_weight !== null ? parseFloat(product.master_pack_gross_weight) : null,
    master_pack_net_weight: product.master_pack_net_weight !== '' && product.master_pack_net_weight !== null ? parseFloat(product.master_pack_net_weight) : null,
    units_per_master: product.units_per_master !== '' && product.units_per_master !== null ? parseInt(product.units_per_master) : null,
    original_factory_cost: product.original_factory_cost !== '' && product.original_factory_cost !== null ? parseFloat(product.original_factory_cost) : null,
    best_cost_with_order: product.best_cost_with_order !== '' && product.best_cost_with_order !== null ? parseFloat(product.best_cost_with_order) : null,
    moq_factory_pack: product.moq_factory_pack !== '' && product.moq_factory_pack !== null && product.moq_factory_pack !== undefined ? parseInt(product.moq_factory_pack) : null,
    logistics_factor: product.logistics_factor !== '' && product.logistics_factor !== null && product.logistics_factor !== undefined ? parseFloat(product.logistics_factor) : null,
    packaging_height: product.packaging_height !== '' && product.packaging_height !== null && product.packaging_height !== undefined ? parseFloat(product.packaging_height) : null,
    packaging_length: product.packaging_length !== '' && product.packaging_length !== null && product.packaging_length !== undefined ? parseFloat(product.packaging_length) : null,
    packaging_width: product.packaging_width !== '' && product.packaging_width !== null && product.packaging_width !== undefined ? parseFloat(product.packaging_width) : null,
    ce_logo: product.ce_logo || false,
    ukca_logo: product.ukca_logo || false,
    cert_en71: product.cert_en71 || false,
    cert_ftalatos: product.cert_ftalatos || false,
    cert_tolueno: product.cert_tolueno || false,
    cert_benceno: product.cert_benceno || false,
  };
};

